(function() {
  'use strict';

  function initLoadMore() {
    const loadMoreButton = document.querySelector('.load-more-button');
    if (!loadMoreButton) return;

    loadMoreButton.addEventListener('click', async function() {
      const nextUrl = this.dataset.nextUrl;
      const sectionId = this.dataset.sectionId;
      
      if (!nextUrl || !sectionId) return;

      // Disable button during loading
      this.disabled = true;
      const originalText = this.textContent;
      this.textContent = 'Loading...';

      try {
        // Fetch next page via Section Rendering API
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Failed to load articles');
        
        const html = await response.text();
        
        // Parse the response HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find the blog articles grid in the response
        const responseGrid = doc.querySelector('.blog-articles');
        const currentGrid = document.querySelector('.blog-articles');
        
        if (responseGrid && currentGrid) {
          // Append new articles to current grid
          const newArticles = responseGrid.querySelectorAll('.blog-articles__article');
          newArticles.forEach(article => {
            currentGrid.appendChild(article.cloneNode(true));
          });
        }
        
        // Update button with next URL or remove if no more pages
        const newLoadMoreButton = doc.querySelector('.load-more-button');
        if (newLoadMoreButton && newLoadMoreButton.dataset.nextUrl) {
          this.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
          this.disabled = false;
          this.textContent = originalText;
        } else {
          // No more pages, remove button
          this.parentElement.remove();
        }
      } catch (error) {
        console.error('Error loading more articles:', error);
        this.disabled = false;
        this.textContent = originalText;
      }
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }

  // Re-initialize for Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && event.detail.sectionId.includes('main-blog')) {
      initLoadMore();
    }
  });
})();
